export type NewSampleFormValues = {
  sampleCode: string;
  wellUid: string;
  depth: string;
  depthUnit: 'ft' | 'm';
  permeability: string;
  porosity: string;
  coreSampleLength: string;
  swi: string;
};

export type FieldErrors = { depth?: string; permeability?: string; porosity?: string };

export const toNumberOrNull = (value: unknown): number | null => {
  if (value === '' || value === null || value === undefined) return null;
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : null;
};

/**
 * Mirrors the backend constraints (AddSampleCommand.depth is a required float;
 * InputSampleValues enforces permeability >= 0 and 0 <= porosity < 1) so the
 * user gets inline feedback and we never hit a 422.
 */
export const validateNewSample = (form: NewSampleFormValues): FieldErrors => {
  const errors: FieldErrors = {};

  const depth = toNumberOrNull(form.depth);
  if (depth === null) {
    errors.depth = 'Depth is required.';
  } else if (depth <= 0) {
    errors.depth = 'Depth must be greater than 0.';
  }

  const permeability = toNumberOrNull(form.permeability);
  if (form.permeability !== '' && (permeability === null || permeability < 0)) {
    errors.permeability = 'Permeability must be ≥ 0.';
  }

  const porosity = toNumberOrNull(form.porosity);
  if (form.porosity !== '' && (porosity === null || porosity < 0 || porosity >= 1)) {
    errors.porosity = 'Porosity must be between 0 and 1 (1 not allowed).';
  }

  return errors;
};
